module.exports = appInfo;